import { render, staticRenderFns } from "./candidateResults.vue?vue&type=template&id=31985104&"
import script from "./candidateResults.vue?vue&type=script&lang=js&"
export * from "./candidateResults.vue?vue&type=script&lang=js&"
import style0 from "./candidateResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports